import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLongArrowAltRight as arrowIcon } from "@fortawesome/free-solid-svg-icons";

const QuestionSummaryList = ({ questions, showInactive, onQuestionClick }) => (
  <>
    {questions.filter(q => showInactive || q.status !== 'inactive').map((question) => (
      <div key={question.questionId} className={`question-container ${question.leadInQuestionId ? 'follow-up' : ''}`}>
        <div className="question-left">
          {question.leadInQuestionId && <FontAwesomeIcon className='font-icon' icon={arrowIcon} />}
          <span className="question-orderNum">{question.orderNum}</span>
          <span className="question-details">
            <span className="question" onClick={() => onQuestionClick(question)}>{question.question}</span> 
            {question.answerType} 
            {question.answerOptions ? ': ' + question.answerOptions : ''}
          </span>
        </div>
        <div className="question-right">
          <span className="question-leadIn">{
            question.leadInOption 
              ? "LeadIn: " + question.leadInOption 
              : question.answerCorrectValues 
                ? "[" + question.answerCorrectValues + "]"
                : "NA"}
          </span>
          <span className="question-status">{question.status}</span>
        </div>
        {question.followupQuestions?.length > 0 && (
          <QuestionSummaryList questions={question.followupQuestions} showInactive={showInactive} onQuestionClick={onQuestionClick} />
        )}
      </div>
    ))}
  </>
);

const SectionQuestions = ({ sectionId, questions, showInactive, onQuestionClick }) => {
  return <QuestionSummaryList questions={questions} showInactive={showInactive} onQuestionClick={onQuestionClick} />;
};

export default SectionQuestions;
